import React, { useCallback, useEffect, useState } from "react";
import ReactModal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";

import AudioCard from "./AudioCard";
import NotesWebcam from "./NotesWebcam";
import UploadAudioButton from "./UploadAudioButton";
import Toastiy from "../../components/common/Toastiy";
import ConfirmToast from "../../components/common/ConfirmToast";
import LoaderSpinner from "../../components/common/LoaderSpinner";
import MyStatefulEditor from "../../components/common/MyStatefulEditor";

import {
  addJournalNoteAction,
  addJournalNoteItemAction,
  deleteJournalAction,
  deleteJournalNoteAction,
  deleteJournalNoteItemAction,
  getBibleSearchAction,
  getUserJournalsAction,
  saveJournalAction,
  setUserJournalsAction,
  updateJournalAction,
  updateJournalNoteAction,
  updateJournalNoteItemAction,
} from "../../store/Bible/BibleAction";
import { uploadAssestsAction } from "../../store/Home/HomeAction";

import { FaPlus } from "react-icons/fa";
import { LuSearch } from "react-icons/lu";
import { MdCancel } from "react-icons/md";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoIosArrowDown, IoIosArrowUp, IoMdClose } from "react-icons/io";

import CloseIcon from "../../assets/icons/Cross.svg";
import Camera from "../../assets/icons/Notes/camera.svg";
import AddBtn from "../../assets/icons/Notes/addBtn.svg";
import AddButton from "../../assets/icons/Notes/addBtn.svg";
import RightTick from "../../assets/icons/Notes/rightTick.svg";
import LeftArrowIcon from "../../assets/icons/leftArrowIcon.svg";
import { debounce } from "../../utils/Utils";
import { toast } from "react-toastify";
import { JOURNAL_NOTE_ITEM_TYPES } from "../../constants/common";

const NotesModel = ({
  isNotesActive,
  setIsNotesActive,
  isNewNotesActive,
  activeVerseDetails,
  setActiveVerseDetails,
  existingJournalId = null,
  onDelete,
  versionDetails,
  onNoteSave,
}) => {
  const dispatch = useDispatch();

  const { userJournals } = useSelector((state) => state.bible);

  const { currentLanguageTitles } = useSelector(
    (state) => state.languageReducer.data
  );

  const [contents, setContents] = useState("");
  const [isWebcamActive, setIsWebcamActive] = useState(false);
  const [newVerseActive, setNewVerseActive] = useState(false);
  const [forceEditorUpdate, setForceEditorUpdate] = useState("");
  const [journalTitle, setJournalTitle] = useState("");
  const [currNoteIndex, setCurrNoteIndex] = useState(0);
  const [journalId, setJorunalId] = useState();
  const [journalLoading, setJournalLoading] = useState(false);

  const [searchTxt, setSearchTxt] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState([]);


  const [journalValues, setJournalValues] = useState({
    journal_id: "",
    notes:
      !existingJournalId && activeVerseDetails
        ? [
            {
              noteObjId: "",
              bookid: activeVerseDetails?.book_id,
              chapterid: activeVerseDetails?.chapter,
              verse_start: activeVerseDetails?.verse_start,
              verse_end: activeVerseDetails?.verse_end,
              notes: activeVerseDetails?.verse_text,
              bookname: activeVerseDetails?.book_name,
              noteitems: [],
            },
          ]
        : [],
  });

  const [originalJournalValues, setOriginalJournalValues] = useState({});


  const fetchJournalDetails = () => {
    setJournalLoading(true);
    dispatch(
      getUserJournalsAction({
        apiPayloadRequest: {
          _id: journalId,
        },
        callback: (response) => {
          const journalData = {
            ...(response.data?.[0] ?? {}),
            notes: [
              ...(activeVerseDetails?.verse_text
                ? [
                    {
                      noteObjId: "",
                      bookid: activeVerseDetails?.book_id,
                      chapterid: activeVerseDetails?.chapter,
                      verse_start: activeVerseDetails?.verse_start,
                      verse_end: activeVerseDetails?.verse_end,
                      notes: activeVerseDetails?.verse_text,
                      bookname: activeVerseDetails?.book_name,
                      noteitems: [],
                    },
                  ]
                : []),
              ...(response?.data?.[0]?.notes
                ? response?.data?.[0]?.notes?.sort(
                    (a, b) =>
                      new Date(b.lastUpdatedDate) - new Date(a.lastUpdatedDate)
                  )
                : []),
            ],
          };
          setJournalValues(journalData);
          setOriginalJournalValues(journalData);
          setJorunalId(response?.data?.[0]?._id);
          setJournalTitle(response?.data?.[0]?.journal_title);
          setCurrNoteIndex(0);
          setJournalLoading(false);
          setActiveVerseDetails({});
        },
      })
    );
  };

  useEffect(() => {
    if (journalId) fetchJournalDetails();
  }, [journalId]);

  useEffect(() => {
    if (existingJournalId) setJorunalId(existingJournalId);
  }, [existingJournalId]);


  const addNote = () => {
    setJournalValues((prev) => ({
      ...prev,
      notes: [...(prev?.notes ?? []), {}],
    }));
    setCurrNoteIndex(journalValues?.notes?.length);
  };

  const fetchUserJournals = () => {
    dispatch(
      getUserJournalsAction({
        callback: (response) => {
          dispatch(setUserJournalsAction(response?.data));
        },
      })
    );
  };

  const isValidJournalTitle = (title) => {
    const regex = /^[A-Za-z0-9\s\-:',.()&]+$/;
    return regex.test(title);
  };

  const handleSaveJournal = (responseCallback = null) => {
    if (!journalTitle.trim()) {
      Toastiy("Add a journal title to proceed further.");
      return;
    }
    if (!isValidJournalTitle(journalTitle)) {
      Toastiy(
        "Journal title contains invalid characters. Please use only letters, numbers, spaces, and basic punctuation (like '-', ':', '&')."
      );
      return;
    }
    if (
      userJournals?.some(
        (d) => d?.journal_title === journalTitle && d?._id !== journalId
      )
    ) {
      toast.error("Journal Already exists with the same name!!");
      return;
    }

    if (journalId && journalValues?.journal_title !== journalTitle) {
      dispatch(
        updateJournalAction({
          apiPayloadRequest: {
            _id: journalId,
            journal_title: journalTitle?.trim(),
          },
          callback: (response) => {
            if (responseCallback) responseCallback(response);
          },
        })
      );
    } else if (!journalId) {
      dispatch(
        saveJournalAction({
          apiPayloadRequest: {
            public: false,
            publish: true,
            journal_title: journalTitle?.trim(),
          },
          callback: (response) => {
            setJorunalId(response?.data?.[0]?._id);
            fetchUserJournals();
            if (responseCallback) responseCallback(response);
          },
        })
      );
    } else {
      if (responseCallback) responseCallback();
    }
  };

  const handleDeleteJournal = () => {
    const options = {
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Are you sure?"
            message="You want to delete this journal?"
            deleteButtonText="Yes"
            onClose={() => onClose()}
            onSuccess={() => {
              dispatch(
                deleteJournalAction({
                  apiPayloadRequest: {
                    _id: journalId,
                  },
                  callback: () => {
                    if (onDelete) {
                      onDelete();
                    }
                    setIsNotesActive(false);
                    toast.success("Journal Deleted Successfully!!", 1);
                  },
                })
              );
              onClose();
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "!bg-gray-500 !bg-opacity-75 z-10000",
    };

    confirmAlert(options);
  };

  const handleSaveNoteItem = (
    noteObjId,
    journalId,
    item,
    noteitemindex,
    responseCallback = null
  ) => {
    const payload = {
      _id: journalId,
      noteObjId: noteObjId,
      type_of_notes: item?.type_of_notes,
      notes: item?.notes ?? "",
      duration: item?.duration ?? "",
      sortOrder: `${noteitemindex + 1}`,
    };
    if (
      [
        JOURNAL_NOTE_ITEM_TYPES.VIDEO,
        JOURNAL_NOTE_ITEM_TYPES.AUDIO,
        JOURNAL_NOTE_ITEM_TYPES.IMAGE,
      ].includes(item?.type_of_notes)
    ) {
      payload.url_link = item?.url_link ?? "";
    }
    if (
      [JOURNAL_NOTE_ITEM_TYPES.VIDEO, JOURNAL_NOTE_ITEM_TYPES.IMAGE].includes(
        item?.type_of_notes
      )
    ) {
      payload.thumbnail = item?.thumbnail ?? "";
    }
    if (JOURNAL_NOTE_ITEM_TYPES.VERSE === item?.type_of_notes) {
      payload.bookid = item?.bookid ?? "";
      payload.chapterid = item?.chapterid ?? "";
      payload.verse_start = item?.verse_start ?? "";
      payload.verse_end = item?.verse_end ?? "";
      payload.bookname = item?.bookname ?? "";
    }
    if (!item?.notesItemObjId) {
      dispatch(
        addJournalNoteItemAction({
          apiPayloadRequest: payload,
          callback: (resp) => {
            if (responseCallback) responseCallback();
          },
        })
      );
    } else if (item?.notesItemObjId && item?.notes) {
      payload.notesItemObjId = item?.notesItemObjId;
      dispatch(
        updateJournalNoteItemAction({
          apiPayloadRequest: payload,
          callback: (resp) => {
            if (responseCallback) responseCallback();
          },
        })
      );
    } else {
      if (responseCallback) responseCallback();
    }
  };

  const handleSaveNote = (index, responseCallback) => {
    const updatedJournalValues = structuredClone(journalValues);
    if (contents?.length > 0) {
      updatedJournalValues.notes[currNoteIndex] = {
        ...(updatedJournalValues.notes[currNoteIndex] ?? {}),
        noteitems: [
          ...(updatedJournalValues.notes[currNoteIndex]?.noteitems ?? []),
          { type_of_notes: JOURNAL_NOTE_ITEM_TYPES.TEXT, notes: contents },
        ],
      };
    }
    if (!journalId) {
      handleSaveJournal((res) => {
        dispatch(
          addJournalNoteAction({
            apiPayloadRequest: {
              _id: res?.data?.[0]?._id,
              notesTitle: " ",
              bookid: updatedJournalValues?.notes?.[index]?.bookid,
              chapterid: updatedJournalValues?.notes?.[index]?.chapterid,
              verse_start: updatedJournalValues?.notes?.[index]?.verse_start,
              verse_end: updatedJournalValues?.notes?.[index]?.verse_end,
              verse_text: updatedJournalValues?.notes?.[index]?.verse_text,
              bookname: updatedJournalValues?.notes?.[index]?.bookname,
              notes: updatedJournalValues?.notes?.[index]?.notes,
              versionid: versionDetails?.abbr,
              languageid: versionDetails?.language_id,
            },
            callback: (response) => {
              const promiseArray = [];
              if (onNoteSave) onNoteSave(response);
              updatedJournalValues?.notes?.[index]?.noteitems?.map(
                (noteitem, noteitemindex) => {
                  promiseArray.push(
                    new Promise((resolve, reject) => {
                      handleSaveNoteItem(
                        response?.noteObjId,
                        res?.data?.[0]?._id,
                        noteitem,
                        noteitemindex,
                        resolve
                      );
                    })
                  );
                }
              );
              Promise.allSettled(promiseArray).then(() => {
                Toastiy("Notes Saved Successfully!!", 1);
                fetchJournalDetails();
                fetchUserJournals();
              });
            },
          })
        );
      });
    } else {
      handleSaveJournal((res) => {
        if (updatedJournalValues?.notes?.[index]?.noteObjId) {
          if (
            originalJournalValues?.notes?.[index]?.bookid !==
            updatedJournalValues?.notes?.[index]?.bookid
          ) {
            dispatch(
              updateJournalNoteAction({
                apiPayloadRequest: {
                  _id: journalId,
                  notesTitle: "",
                  noteObjId: updatedJournalValues?.notes?.[index]?.noteObjId,
                  bookid: updatedJournalValues?.notes?.[index]?.bookid,
                  chapterid: updatedJournalValues?.notes?.[index]?.chapterid,
                  verse_start:
                    updatedJournalValues?.notes?.[index]?.verse_start,
                  verse_end: updatedJournalValues?.notes?.[index]?.verse_end,
                  verse_text: updatedJournalValues?.notes?.[index]?.verse_text,
                  bookname: updatedJournalValues?.notes?.[index]?.bookname,
                  versionid: updatedJournalValues?.notes?.[index]?.versionid,
                  languageid: updatedJournalValues?.notes?.[index]?.languageid,
                },
                callback: (response) => {
                  Toastiy("Notes Updated Successfully!!", 1);
                },
              })
            );
          }
          const promiseArray = [];
          updatedJournalValues?.notes?.[index]?.noteitems?.map(
            (noteitem, noteitemindex) => {
              promiseArray.push(
                new Promise((resolve, reject) => {
                  handleSaveNoteItem(
                    updatedJournalValues?.notes?.[index]?.noteObjId,
                    journalId,
                    noteitem,
                    noteitemindex,
                    resolve
                  );
                })
              );
            }
          );
          Promise.allSettled(promiseArray).then(() => {
            fetchJournalDetails();
            fetchUserJournals();
          });
        } else {
          dispatch(
            addJournalNoteAction({
              apiPayloadRequest: {
                _id: journalId,
                notesTitle: " ",
                bookid: updatedJournalValues?.notes?.[index]?.bookid,
                chapterid: updatedJournalValues?.notes?.[index]?.chapterid,
                verse_start: updatedJournalValues?.notes?.[index]?.verse_start,
                verse_end: updatedJournalValues?.notes?.[index]?.verse_end,
                verse_text: updatedJournalValues?.notes?.[index]?.verse_text,
                bookname: updatedJournalValues?.notes?.[index]?.bookname,
                notes: updatedJournalValues?.notes?.[index]?.notes,
                versionid: versionDetails?.abbr,
                languageid: versionDetails?.language_id,
              },
              callback: (response) => {
                const promiseArray = [];
                if (onNoteSave) onNoteSave(response);
                updatedJournalValues?.notes?.[index]?.noteitems?.map(
                  (noteitem, noteitemindex) => {
                    promiseArray.push(
                      new Promise((resolve, reject) => {
                        handleSaveNoteItem(
                          response?.noteObjId,
                          journalId,
                          noteitem,
                          noteitemindex,
                          resolve
                        );
                      })
                    );
                  }
                );
                Promise.allSettled(promiseArray).then(() => {
                  fetchJournalDetails();
                  fetchUserJournals();
                });
                Toastiy("Notes Saved Successfully!!", 1);
              },
            })
          );
        }
      });
    }

    if (contents?.length > 0) {
      setContents("");
      setForceEditorUpdate(true);
      setTimeout(() => {
        setForceEditorUpdate(false);
      }, 500);
    }
  };

  const handleDeleteNote = (item, index) => {
    const options = {
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Are you sure?"
            message="You want to delete this note?"
            deleteButtonText="Yes"
            onClose={() => onClose()}
            onSuccess={() => {
              if (item?.noteObjId) {
                dispatch(
                  deleteJournalNoteAction({
                    apiPayloadRequest: {
                      _id: journalId,
                      noteObjId: item?.noteObjId,
                    },
                    callback: () => {
                      fetchJournalDetails();
                      fetchUserJournals();
                    },
                  })
                );
              }
              setJournalValues((prev) => {
                const updatedData = structuredClone(prev);
                updatedData?.notes?.splice(index, 1);
                return updatedData;
              });
              toast.success("Notes Deleted Successfully!!");
              onClose();
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "!bg-gray-500 !bg-opacity-75 z-10000",
    };

    confirmAlert(options);
  };

  const handleDeleteNoteItem = (item, noteIndex, itemIndex) => {
    const options = {
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Are you sure?"
            message="You want to delete this item?"
            deleteButtonText="Yes"
            onClose={() => onClose()}
            onSuccess={() => {
              if (
                journalValues?.notes?.[noteIndex]?.noteitems?.[itemIndex]
                  ?.notesItemObjId
              ) {
                dispatch(
                  deleteJournalNoteItemAction({
                    apiPayloadRequest: {
                      _id: journalId,
                      noteObjId: journalValues?.notes?.[noteIndex]?.noteObjId,
                      notesItemObjId:
                        journalValues?.notes?.[noteIndex]?.noteitems?.[
                          itemIndex
                        ]?.notesItemObjId,
                    },
                    callback: () => {
                      // setIsNotesActive(false);
                      toast.success("Note Item Deleted Successfully!!");
                    },
                  })
                );
              }
              setJournalValues((prev) => {
                const updatedData = structuredClone(prev);
                updatedData?.notes?.[noteIndex]?.noteitems?.splice(
                  itemIndex,
                  1
                );
                return updatedData;
              });
              onClose();
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "!bg-gray-500 !bg-opacity-75 z-10000",
    };

    confirmAlert(options);
  };

  const getAudioDuration = (file) => {
    return new Promise((resolve, reject) => {
      const audio = document.createElement("audio");
      audio.preload = "metadata";
      audio.src = URL.createObjectURL(file);
      audio.onloadedmetadata = () => {
        URL.revokeObjectURL(audio.src);
        resolve(audio.duration);
      };
      audio.onerror = (e) => {
        reject(e);
      };
    });
  };

  const uploadAsset = (noteIndex, itemIndex, file, itemKey = "url_link") => {
    const actualNoteItemIndex = itemIndex ? itemIndex : 0;
    dispatch(
      uploadAssestsAction({
        apiPayloadRequest: { file: file },
        callback: (response) => {
          setJournalValues((prev) => {
            const updatedData = structuredClone(prev);
            if (!updatedData.notes || updatedData.notes?.length === 0) {
              updatedData.notes = [{}];
            }
            if (
              !updatedData.notes[noteIndex].noteitems ||
              updatedData.notes[noteIndex].noteitems?.length === 0
            ) {
              updatedData.notes[noteIndex].noteitems = [{}];
            }
            updatedData.notes[noteIndex].noteitems[actualNoteItemIndex][
              itemKey
            ] = response?.url;
            updatedData.notes[noteIndex].noteitems[
              actualNoteItemIndex
            ].isLoading = false;
            return updatedData;
          });
        },
      })
    );
  };

  const handleSearch = (search) => {
    setIsSearching(true);
    if (search) {
      dispatch(
        getBibleSearchAction({
          apiPayloadRequest: {
            filesetid: versionDetails?.abbr,
            question: search,
          },
          callback: (res) => {
            setSearchResults(res?.data ?? []);
            setIsSearching(false);
          },
        })
      );
    } else {
      setSearchResults([]);
      setIsSearching(false);
    }
  };

  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [fullscreenVideo, setFullscreenVideo] = useState(null);

  return (
    <>
      <ReactModal
        isOpen={isNotesActive}
        className={"overflow-hidden"}
        onRequestClose={() => setIsNotesActive(false)}
      >
        <div className="relative flex h-[100vh] w-full flex-col items-center justify-center gap-6 bg-blackish">
          <div className="relative flex h-[80%] w-[90%] flex-col rounded-2xl bg-blackishV2 py-6 md:h-[90%] md:w-[50%]">
            <button
              className="absolute -right-4 -top-4 text-4xl"
              onClick={() => setIsNotesActive(false)}
            >
              <MdCancel color="#EFBC51" />
            </button>
            {journalLoading ? (
              <div className="bg-white/05 flex h-full w-full items-center justify-center">
                <LoaderSpinner />
              </div>
            ) : (
              <div className="custom-scrollbar flex h-full w-full flex-col overflow-y-auto px-4 md:px-12">
                <div className="flex w-full items-center justify-between">
                  <div className="flex items-center gap-3 text-2xl font-semibold text-yellowish">
                    <img
                      src={LeftArrowIcon}
                      alt="LeftArrowIcon"
                      className="cursor-pointer"
                      onClick={() => setIsNotesActive(false)}
                    />
                    <input
                      type="text"
                      placeholder={
                        currentLanguageTitles?.[0]?.bible
                          ?.jorunal_title_placeholder ?? "Add Title"
                      }
                      className="ml-3 border-b border-yellowish bg-transparent text-yellowish outline-none"
                      value={journalTitle}
                      onChange={(e) => {
                        setJournalTitle(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {journalValues?.notes?.map((noteItem, noteIndex) => (
                  <div
                    className={`overflow relative mt-5 flex max-h-[75vh] flex-col border bg-blackish p-3 pr-5 md:p-5 md:pr-8 ${
                      noteIndex === currNoteIndex
                        ? "border-yellowish/50"
                        : "!h-24 cursor-pointer border-greyish/40"
                    } ${
                      noteIndex % 2 === 0
                        ? "rounded-ee-3xl rounded-ss-3xl"
                        : "rounded-es-3xl rounded-se-3xl"
                    }`}
                    onClick={() => {
                      setCurrNoteIndex(noteIndex);
                      if (noteIndex === currNoteIndex) {
                        setCurrNoteIndex(null);
                      } else {
                        setCurrNoteIndex(noteIndex);
                      }
                    }}
                  >
                    <span className="absolute left-3 top-3 cursor-pointer text-yellowish">
                      {noteIndex === currNoteIndex ? (
                        <IoIosArrowUp />
                      ) : (
                        <IoIosArrowDown />
                      )}
                    </span>
                    <RiDeleteBin5Line
                      className="absolute right-3 top-3 cursor-pointer text-lg text-red-500"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteNote(noteItem, noteIndex);
                      }}
                    />
                    <div
                      className={`w-full flex-1 pb-10 pr-2 ${
                        noteIndex === currNoteIndex
                          ? "custom-scrollbar overflow-y-auto"
                          : "overflow-y-hidden"
                      }`}
                      onClick={(e) => {
                        if (noteIndex === currNoteIndex) e.stopPropagation();
                      }}
                    >
                      {noteItem?.verse_start && (
                        <div className="relative w-full py-2">
                          <div className="flex gap-4 py-2 text-greyish">
                            <h3 className="text-2xl font-semibold">
                              {noteItem?.bookname}{" "}
                              <span>
                                {noteItem?.chapterid}:{noteItem?.verse_start}
                              </span>
                            </h3>
                          </div>
                          <p className="text-greyish">{noteItem?.notes}</p>

                          <FiMinusCircle
                            className="absolute -right-1 top-5 cursor-pointer text-white"
                            onClick={() => {
                              setJournalValues((prev) => {
                                const updatedData = structuredClone(prev);
                                delete updatedData.notes[noteIndex]?.bookid;
                                delete updatedData.notes[noteIndex]?.chapterid;
                                delete updatedData.notes[noteIndex]
                                  ?.verse_start;
                                delete updatedData.notes[noteIndex]?.verse_end;
                                delete updatedData.notes[noteIndex]?.verse_text;
                                delete updatedData.notes[noteIndex]?.bookname;
                                return updatedData;
                              });
                            }}
                          />
                        </div>
                      )}
                      {noteItem?.noteitems?.map((item, noteItemIndex) => {
                        if (
                          item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VERSE
                        ) {
                          return (
                            <div
                              className="relative w-full py-2"
                              key={`note-item${noteItemIndex}`}
                            >
                              <div className="flex gap-4 py-2 text-white">
                                <h3 className="text-2xl font-semibold">
                                  {item?.bookname}{" "}
                                  <span>
                                    {item?.chapterid}:{item?.verse_start}
                                  </span>
                                </h3>
                              </div>
                              <p className="text-greyish">{item?.notes}</p>
                              <FiMinusCircle
                                className="absolute -right-1 top-5 cursor-pointer text-white"
                                onClick={() =>
                                  handleDeleteNoteItem(
                                    noteItem,
                                    noteIndex,
                                    noteItemIndex
                                  )
                                }
                              />
                            </div>
                          );
                        } else if (
                          item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.TEXT
                        ) {
                          return (
                            <div
                              className="relative w-full py-3 text-greyish"
                              key={`note-item${noteItemIndex}`}
                            >
                              <MyStatefulEditor
                                forceEditorUpdate={forceEditorUpdate}
                                labelColor="white"
                                labelText=""
                                darkMode={true}
                                placeholder="| What's God speaking to you?"
                                htmlFor="currNotesText"
                                name="currNotesText"
                                value={item?.notes}
                                handleInputChange={(e) => {
                                  setJournalValues((prev) => {
                                    const updatedData = structuredClone(prev);
                                    updatedData.notes[noteIndex].noteitems[
                                      noteItemIndex
                                    ].notes = e.target.value;
                                    return updatedData;
                                  });
                                }}
                                largeToolbar={true}
                                showToolbarOnFocus={true}
                              />
                              <FiMinusCircle
                                className="absolute -right-1 top-5 cursor-pointer text-white"
                                onClick={() =>
                                  handleDeleteNoteItem(
                                    noteItem,
                                    noteIndex,
                                    noteItemIndex
                                  )
                                }
                              />
                            </div>
                          );
                        } else if (
                          item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.IMAGE
                        ) {
                          return (
                            <div
                              className="relative w-full py-3 text-greyish"
                              key={`note-item${noteItemIndex}`}
                            >
                              {item?.isLoading ? (
                                <LoaderSpinner />
                              ) : (
                                item?.url_link && (
                                  <>
                                    <img
                                      src={item?.url_link}
                                      alt={"image" + (noteItemIndex + 1)}
                                      className="col-span-3 max-h-[75vh] max-w-full cursor-pointer object-contain"
                                      onClick={() =>
                                        setFullscreenImage(item?.url_link)
                                      }
                                    />
                                    {item?.notes && (
                                      <MyStatefulEditor
                                        forceEditorUpdate={forceEditorUpdate}
                                        labelColor="white"
                                        labelText=""
                                        darkMode={true}
                                        placeholder="| What's God speaking to you?"
                                        htmlFor="currNotesText"
                                        name="currNotesText"
                                        value={item?.notes}
                                        handleInputChange={(e) => {
                                          setJournalValues((prev) => {
                                            const updatedData =
                                              structuredClone(prev);
                                            updatedData.notes[
                                              noteIndex
                                            ].noteitems[noteItemIndex].notes =
                                              e.target.value;
                                            return updatedData;
                                          });
                                        }}
                                        largeToolbar={true}
                                        showToolbarOnFocus={true}
                                      />
                                    )}
                                  </>
                                )
                              )}
                              <FiMinusCircle
                                className="absolute -right-1 top-5 cursor-pointer text-white"
                                onClick={() =>
                                  handleDeleteNoteItem(
                                    noteItem,
                                    noteIndex,
                                    noteItemIndex
                                  )
                                }
                              />
                            </div>
                          );
                        } else if (
                          item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.VIDEO
                        ) {
                          return (
                            <div
                              className="relative w-full py-3 text-greyish"
                              key={`note-item${noteItemIndex}`}
                            >
                              {item?.isLoading ? (
                                <LoaderSpinner />
                              ) : item?.thumbnail ? (
                                <div
                                  className="flex cursor-pointer items-center"
                                  onClick={() =>
                                    setFullscreenVideo(item?.url_link)
                                  }
                                >
                                  <div className="relative max-h-[75vh] w-8/12">
                                    <img
                                      src={item.thumbnail}
                                      alt={
                                        "video-thumbnail-" + (noteItemIndex + 1)
                                      }
                                      className="h-full w-full rounded object-contain"
                                    />
                                    <span className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
                                      <svg
                                        width="64"
                                        height="64"
                                        viewBox="0 0 64 64"
                                      >
                                        <circle
                                          cx="32"
                                          cy="32"
                                          r="32"
                                          fill="rgba(0,0,0,0.5)"
                                        />
                                        <polygon
                                          points="26,20 48,32 26,44"
                                          fill="#fff"
                                        />
                                      </svg>
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                item?.url_link && (
                                  <video
                                    src={item?.url_link}
                                    alt={"video" + (noteItemIndex + 1)}
                                    className="max-h-[75vh] w-8/12 max-w-full border border-greyishV2 bg-greyishV3 object-contain"
                                    controls={false}
                                    onClick={() =>
                                      setFullscreenVideo(item?.url_link)
                                    }
                                  />
                                )
                              )}
                              {item?.notes && (
                                <MyStatefulEditor
                                  forceEditorUpdate={forceEditorUpdate}
                                  labelColor="white"
                                  labelText=""
                                  darkMode={true}
                                  placeholder="| What's God speaking to you?"
                                  htmlFor="currNotesText"
                                  name="currNotesText"
                                  value={item?.notes}
                                  handleInputChange={(e) => {
                                    setJournalValues((prev) => {
                                      const updatedData = structuredClone(prev);
                                      updatedData.notes[noteIndex].noteitems[
                                        noteItemIndex
                                      ].notes = e.target.value;
                                      return updatedData;
                                    });
                                  }}
                                  largeToolbar={true}
                                  showToolbarOnFocus={true}
                                />
                              )}
                              <FiMinusCircle
                                className="absolute -right-1 top-5 cursor-pointer text-white"
                                onClick={() =>
                                  handleDeleteNoteItem(
                                    noteItem,
                                    noteIndex,
                                    noteItemIndex
                                  )
                                }
                              />
                            </div>
                          );
                        } else if (
                          item?.type_of_notes === JOURNAL_NOTE_ITEM_TYPES.AUDIO
                        ) {
                          return (
                            <div
                              className="relative grid w-full grid-cols-3 gap-2 py-3 text-greyish"
                              key={`note-item${noteItemIndex}`}
                            >
                              <AudioCard
                                url={item?.url_link}
                                duration={item?.duration}
                              />
                              <FiMinusCircle
                                className="absolute -right-1 top-5 cursor-pointer text-white"
                                onClick={() =>
                                  handleDeleteNoteItem(
                                    noteItem,
                                    noteIndex,
                                    noteItemIndex
                                  )
                                }
                              />
                            </div>
                          );
                        }
                        return null;
                      })}

                      {noteIndex === currNoteIndex && (
                        <div className="group relative">
                          {(journalValues?.notes?.[currNoteIndex]?.noteitems
                            ?.length > 0 ||
                            journalValues?.notes?.[currNoteIndex]
                              ?.verse_start) && (
                            <div className="mt-4 w-full border-b-2 border-greyishV2"></div>
                          )}
                          {contents && (
                            <FiPlusCircle
                              onClick={() => {
                                setJournalValues((prev) => {
                                  const updatedData = structuredClone(prev);
                                  updatedData.notes[currNoteIndex] = {
                                    ...(updatedData.notes[currNoteIndex] ?? {}),
                                    noteitems: [
                                      ...(updatedData.notes[currNoteIndex]
                                        ?.noteitems ?? []),
                                      {
                                        type_of_notes:
                                          JOURNAL_NOTE_ITEM_TYPES.TEXT,
                                        notes: contents,
                                      },
                                    ],
                                  };
                                  return updatedData;
                                });
                                setContents("");
                                setForceEditorUpdate(true);
                                setTimeout(() => {
                                  setForceEditorUpdate(false);
                                }, 500);
                              }}
                              className="absolute -right-2 top-1/2 z-[2000] hidden -translate-y-1/2 cursor-pointer rounded-full bg-blackishV2 text-lg text-white group-hover:block"
                            />
                          )}
                          <MyStatefulEditor
                            forceEditorUpdate={forceEditorUpdate}
                            labelColor="white"
                            labelText=""
                            darkMode={true}
                            placeholder="| What's God speaking to you?"
                            htmlFor="currNotesText"
                            name="currNotesText"
                            value={contents}
                            handleInputChange={(e) => {
                              setContents(e.target.value);
                            }}
                            largeToolbar={true}
                            showToolbarOnFocus={true}
                          />
                        </div>
                      )}
                    </div>
                    {noteIndex === currNoteIndex && (
                      <>
                        {!newVerseActive && (
                          <div
                            className="flex w-full items-end justify-between pt-3"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex items-center gap-3">
                              <div
                                className="cursor-pointer rounded-md border border-greyishV2 px-3 py-[6px]"
                                onClick={() => setIsWebcamActive(true)}
                              >
                                <img src={Camera} alt="Camera" />
                              </div>
                              <UploadAudioButton
                                handleAudioUpload={async (e) => {
                                  const duration = await getAudioDuration(
                                    e.target.files?.[0]
                                  );
                                  setJournalValues((prev) => {
                                    const itemIndex =
                                      prev?.notes?.[currNoteIndex]?.noteitems
                                        ?.length;
                                    const updatedData = structuredClone(prev);
                                    updatedData.notes[currNoteIndex] = {
                                      ...(updatedData.notes[currNoteIndex] ??
                                        {}),
                                      noteitems: [
                                        ...(updatedData.notes[currNoteIndex]
                                          ?.noteitems ?? []),
                                        ...(contents?.length > 0
                                          ? [
                                              {
                                                type_of_notes:
                                                  JOURNAL_NOTE_ITEM_TYPES.TEXT,
                                                notes: contents,
                                              },
                                            ]
                                          : []),
                                        {
                                          type_of_notes:
                                            JOURNAL_NOTE_ITEM_TYPES.AUDIO,
                                          url_link: "",
                                          isLoading: true,
                                          duration: duration,
                                        },
                                      ],
                                    };
                                    uploadAsset(
                                      currNoteIndex,
                                      contents?.length > 0
                                        ? itemIndex + 1
                                        : itemIndex,
                                      e.target.files[0]
                                    );
                                    return updatedData;
                                  });
                                  if (contents !== "") {
                                    setContents("");
                                    setForceEditorUpdate(true);
                                    setTimeout(() => {
                                      setForceEditorUpdate(false);
                                    }, 500);
                                  }
                                }}
                                handleAudioCapture={(file, duration) => {
                                  setJournalValues((prev) => {
                                    const itemIndex =
                                      prev?.notes?.[currNoteIndex]?.noteitems
                                        ?.length;
                                    const updatedData = structuredClone(prev);
                                    updatedData.notes[currNoteIndex] = {
                                      ...(updatedData.notes[currNoteIndex] ??
                                        {}),
                                      noteitems: [
                                        ...(updatedData.notes[currNoteIndex]
                                          ?.noteitems ?? []),
                                        ...(contents?.length > 0
                                          ? [
                                              {
                                                type_of_notes:
                                                  JOURNAL_NOTE_ITEM_TYPES.TEXT,
                                                notes: contents,
                                              },
                                            ]
                                          : []),
                                        {
                                          type_of_notes:
                                            JOURNAL_NOTE_ITEM_TYPES.AUDIO,
                                          url_link: "",
                                          isLoading: true,
                                          duration: duration,
                                        },
                                      ],
                                    };
                                    uploadAsset(
                                      currNoteIndex,
                                      contents?.length > 0
                                        ? itemIndex + 1
                                        : itemIndex,
                                      file
                                    );
                                    return updatedData;
                                  });
                                  if (contents?.length > 0) {
                                    setContents("");
                                    setForceEditorUpdate(true);
                                    setTimeout(() => {
                                      setForceEditorUpdate(false);
                                    }, 500);
                                  }
                                }}
                              />
                              <div
                                className="flex cursor-pointer items-center gap-1 rounded-md border border-greyishV2 px-2 py-1 text-greyish"
                                onClick={() => setNewVerseActive(true)}
                              >
                                <img src={AddBtn} alt="AddBtn" />
                                <span className="hidden md:block">
                                  {currentLanguageTitles?.[0]?.bible
                                    ?.verse_lbl ?? "Verse"}
                                </span>
                              </div>
                            </div>
                            <div
                              className="cursor-pointer rounded-md border border-yellowish px-4 py-[10px] md:px-8"
                              onClick={() => {
                                handleSaveNote(noteIndex);
                              }}
                            >
                              <img src={RightTick} alt="RightTick" />
                            </div>
                          </div>
                        )}
                        {newVerseActive && (
                          <div
                            className="w-full rounded-2xl bg-greyishV2 p-3 md:p-8"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="flex w-full items-center gap-4 px-2 pb-5">
                              <div className="flex w-full items-center justify-between gap-3 rounded-md bg-greyish px-3 py-1.5">
                                <input
                                  type="text"
                                  value={searchTxt}
                                  placeholder={
                                    currentLanguageTitles?.[0]?.bible
                                      ?.bible_search_placeholder ??
                                    "Search the Biblee"
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  onChange={(e) => setSearchTxt(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      handleSearch(searchTxt);
                                    }
                                  }}
                                  className="w-full bg-greyish text-blackish outline-none placeholder:text-blackish"
                                />
                                <button
                                  className="flex aspect-square items-center justify-center rounded-full bg-white p-1"
                                  onClick={() => handleSearch(searchTxt)}
                                >
                                  <LuSearch className="text-xl text-blackish" />
                                </button>
                              </div>
                              <img
                                src={CloseIcon}
                                alt="CloseIcon"
                                className="h-5 cursor-pointer"
                                onClick={() => setNewVerseActive(false)}
                              />
                            </div>
                            <ul className="custom-scrollbar flex max-h-[30vh] flex-1 flex-col gap-1 overflow-y-auto pr-2">
                              {!isSearching &&
                                searchResults?.map((item, index) => {
                                  return (
                                    <div
                                      key={`search-item${index}`}
                                      className="cursor-pointer rounded-md px-2 py-2 text-white hover:bg-black/30"
                                      onClick={() => {
                                        setJournalValues((prev) => {
                                          const updatedData =
                                            structuredClone(prev);
                                          updatedData.notes[currNoteIndex] = {
                                            ...(updatedData.notes[
                                              currNoteIndex
                                            ] ?? {}),
                                            noteitems: [
                                              ...(updatedData.notes[
                                                currNoteIndex
                                              ]?.noteitems ?? []),
                                              ...(contents?.length > 0
                                                ? [
                                                    {
                                                      type_of_notes:
                                                        JOURNAL_NOTE_ITEM_TYPES.TEXT,
                                                      notes: contents,
                                                    },
                                                  ]
                                                : []),
                                              {
                                                type_of_notes:
                                                  JOURNAL_NOTE_ITEM_TYPES.VERSE,
                                                verse_start: item?.verse_start,
                                                verse_end: item?.verse_end,
                                                bookname: item?.book_name,
                                                bookid: item?.book_id,
                                                chapterid: item?.chapter,
                                                notes: item?.verse_text,
                                              },
                                            ],
                                          };
                                          return updatedData;
                                        });
                                        if (contents?.length > 0) {
                                          setContents("");
                                          setForceEditorUpdate(true);
                                          setTimeout(() => {
                                            setForceEditorUpdate(false);
                                          }, 500);
                                        }
                                        setNewVerseActive(false);
                                      }}
                                    >
                                      <p className="">{item?.verse_text}</p>
                                      <div className="flex w-full items-center justify-between text-sm text-greyishV3">
                                        <p className="">
                                          {item?.book_name}{" "}
                                          <span className="">
                                            {item?.chapterid}:
                                            {item?.verse_start}
                                          </span>
                                        </p>
                                        <img
                                          src={AddButton}
                                          alt="plusButtonIcon"
                                          className="cursor-pointer"
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                              {isSearching && (
                                <li className="flex cursor-pointer flex-col items-center justify-center gap-2 py-5 text-yellowish">
                                  <LoaderSpinner />
                                  <p>Loading Results..</p>
                                </li>
                              )}
                              {!isSearching && searchResults?.length === 0 && (
                                <li className="flex cursor-pointer flex-col items-center justify-center gap-2 py-10 text-yellowish">
                                  <p>
                                    {currentLanguageTitles?.[0]?.bible
                                      ?.no_results_lbl ?? "No Results Found"}
                                  </p>
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}

                <div
                  className="mt-5 flex cursor-pointer items-center gap-3 rounded-full rounded-tr-none border border-greyishV2 bg-blackish px-5 py-3 text-sm text-white"
                  onClick={addNote}
                >
                  <FaPlus />
                  <span>
                    {currentLanguageTitles?.[0]?.bible?.add_new_section_lbl ??
                      "Add New Section"}
                  </span>
                </div>
                {journalId && (
                  <div
                    className="mt-5 flex cursor-pointer items-center justify-between gap-3 rounded-full rounded-tr-none border border-red-500 bg-red-500 px-5 py-3 text-sm text-white"
                    onClick={handleDeleteJournal}
                  >
                    <span>
                      {currentLanguageTitles?.[0]?.bible?.delete_journal_lbl ??
                        "Delete Journal"}
                    </span>
                    <RiDeleteBin5Line className="text-lg" />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </ReactModal>
      {isWebcamActive && (
        <NotesWebcam
          addItem={(file, type, caption, thumbnail) => {
            setJournalValues((prev) => {
              const itemIndex = prev?.notes?.[currNoteIndex]?.noteitems?.length;
              const updatedData = structuredClone(prev);
              updatedData.notes[currNoteIndex] = {
                ...(updatedData.notes[currNoteIndex] ?? {}),
                noteitems: [
                  ...(updatedData.notes[currNoteIndex]?.noteitems ?? []),
                  ...(contents?.length > 0
                    ? [
                        {
                          type_of_notes: JOURNAL_NOTE_ITEM_TYPES.TEXT,
                          notes: contents,
                        },
                      ]
                    : []),
                  {
                    type_of_notes:
                      type === "image"
                        ? JOURNAL_NOTE_ITEM_TYPES.IMAGE
                        : JOURNAL_NOTE_ITEM_TYPES.VIDEO,
                    url_link: "",
                    isLoading: true,
                    notes: caption || "", // Save caption here
                  },
                ],
              };
              uploadAsset(
                currNoteIndex,
                contents?.length > 0 ? itemIndex + 1 : itemIndex,
                file
              );
              if (thumbnail) {
                uploadAsset(
                  currNoteIndex,
                  contents?.length > 0 ? itemIndex + 1 : itemIndex,
                  thumbnail,
                  "thumbnail"
                );
              }
              return updatedData;
            });
            if (contents?.length > 0) {
              setContents("");
              setForceEditorUpdate(true);
              setTimeout(() => {
                setForceEditorUpdate(false);
              }, 500);
            }
          }}
          isOpen={isWebcamActive}
          onClose={setIsWebcamActive}
        />
      )}

      {/* Fullscreen Image Modal */}
      <ReactModal
        isOpen={!!fullscreenImage}
        onRequestClose={() => setFullscreenImage(null)}
        className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90 outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-90 z-[99999]"
        ariaHideApp={false}
      >
        <div className="relative flex h-full w-full items-center justify-center">
          <button
            className="absolute right-4 top-4 z-50 rounded-full bg-yellowish p-2 text-2xl text-blackish"
            onClick={() => setFullscreenImage(null)}
          >
            <IoMdClose alt="Close" />
          </button>
          <img
            src={fullscreenImage}
            alt="Fullscreen"
            className="mx-auto max-h-[90vh] max-w-[90vw] rounded-xl object-contain"
          />
        </div>
      </ReactModal>

      {/* Fullscreen Video Modal */}
      <ReactModal
        isOpen={!!fullscreenVideo}
        onRequestClose={() => setFullscreenVideo(null)}
        className="fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-90 outline-none"
        overlayClassName="fixed inset-0 bg-black bg-opacity-90 z-[99999]"
        ariaHideApp={false}
      >
        <div className="relative flex h-full w-full items-center justify-center">
          <button
            className="absolute right-4 top-4 z-50 rounded-full bg-yellowish p-2 text-2xl text-blackish"
            onClick={() => setFullscreenVideo(null)}
          >
            <IoMdClose alt="Close" />
          </button>
          <video
            src={fullscreenVideo}
            controls
            autoPlay
            className="mx-auto max-h-[90vh] max-w-[90vw] rounded-xl object-contain"
          />
        </div>
      </ReactModal>
    </>
  );
};

export default NotesModel;
